/**
 * Measurements service
 */

import { apiClient } from '../utils/api';
import type { Measurement, ApiResponse } from '../../../shared/src/types';

export interface CreateMeasurementData {
  installation_id: string;
  checklist_item_run_id?: string;
  type: string;
  value: number;
  unit: string;
  notes?: string;
}

export async function createMeasurement(data: CreateMeasurementData): Promise<Measurement> {
  const response = await apiClient.post<ApiResponse<Measurement>>('/measurements', data);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error creating measurement');
  }

  if (!response.data.data) {
    throw new Error('Invalid response from server');
  }

  return response.data.data;
}

export async function listMeasurements(installationId?: string, checklistItemRunId?: string): Promise<Measurement[]> {
  const queryParams = new URLSearchParams();
  if (installationId) queryParams.append('installation_id', installationId);
  if (checklistItemRunId) queryParams.append('checklist_item_run_id', checklistItemRunId);

  const url = `/measurements${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response = await apiClient.get<ApiResponse<Measurement[]>>(url);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error fetching measurements');
  }

  return response.data.data || [];
}

export async function getMeasurement(id: string): Promise<Measurement> {
  const response = await apiClient.get<ApiResponse<Measurement>>(`/measurements/${id}`);

  if (response.data.error) {
    throw new Error(response.data.error.message || 'Error fetching measurement');
  }

  if (!response.data.data) {
    throw new Error('Measurement not found');
  }

  return response.data.data;
}

